(() => {
  const SELECTOR = 'media-gallery .thumbnail-slider';

  function visibleItems(slider) {
    return Array.from(slider.querySelectorAll('.thumbnail-list__item')).filter((item) => {
      if (item.classList.contains('hidden')) return false;
      if (item.hasAttribute('hidden')) return false;
      const style = window.getComputedStyle(item);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  function getActiveIndex(items) {
    const activeIndex = items.findIndex((item) => item.classList.contains('is-active') || item.querySelector('.thumbnail[aria-current="true"], .thumbnail[aria-current="true"]'));
    return activeIndex > -1 ? activeIndex : 0;
  }

  function activateItem(item) {
    const button = item?.querySelector('button.thumbnail, button[data-media-id], button');
    if (!button) return;
    button.click();
    setTimeout(() => {
      item.closest('thumbnail-slider')?.querySelector('.thumbnail-list')?.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
    }, 60);
  }

  function updateButtons(slider) {
    const items = visibleItems(slider);
    const buttons = slider.querySelectorAll('.slider-button');
    const shouldEnable = items.length > 1;

    buttons.forEach((button) => {
      if (shouldEnable) {
        button.disabled = false;
        button.removeAttribute('disabled');
        button.setAttribute('aria-disabled', 'false');
      } else {
        button.disabled = true;
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function move(slider, direction) {
    const items = visibleItems(slider);
    if (items.length < 2) return;

    const current = getActiveIndex(items);
    const next = direction === 'next'
      ? (current + 1) % items.length
      : (current - 1 + items.length) % items.length;

    activateItem(items[next]);
    setTimeout(() => updateButtons(slider), 80);
  }

  function enhance(slider) {
    if (!slider || slider.dataset.vpDotsArrowsEnhanced === 'true') return;
    slider.dataset.vpDotsArrowsEnhanced = 'true';

    const prev = slider.querySelector('.slider-button--prev, button[name="previous"]');
    const next = slider.querySelector('.slider-button--next, button[name="next"]');

    if (prev) {
      prev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        move(slider, 'previous');
      }, true);
    }

    if (next) {
      next.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        move(slider, 'next');
      }, true);
    }

    slider.querySelectorAll('.thumbnail').forEach((button) => {
      button.addEventListener('click', () => setTimeout(() => updateButtons(slider), 80));
    });

    const observer = new MutationObserver(() => updateButtons(slider));
    observer.observe(slider, { subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-current', 'class', 'hidden', 'style'] });

    updateButtons(slider);
    setTimeout(() => updateButtons(slider), 250);
    setTimeout(() => updateButtons(slider), 900);
    window.addEventListener('resize', () => updateButtons(slider), { passive: true });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(enhance);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();
